export default "__VITE_ASSET___hmjITZd__"